import type { LearnPracticalContent } from "../practicalContent.js";

export const fireEvacuationContent: LearnPracticalContent = {
  th: {
    notice: [
      "ควันและก๊าซจากไฟไหม้อาจเป็นอันตรายก่อนที่ไฟจะมาถึง",
      "ทางออกและบันไดหนีไฟของแต่ละอาคารไม่เหมือนกัน",
      "สัญญาณเตือน กลิ่นไหม้ ควัน หรือประตูที่ร้อนผิดปกติเป็นเหตุให้ออกจากอาคารโดยไม่รอเก็บของ",
      "อพาร์ตเมนต์ คอนโด สำนักงาน และโรงแรมอาจมีจุดรวมพลหรือคำสั่งอพยพต่างกัน ควรอ่านป้ายของสถานที่นั้นเมื่อมาถึง",
    ],
    prepare: [
      "รู้ทางออกอย่างน้อยสองทางและจุดรวมพลของอาคาร",
      "ให้ทางเดิน ประตู และบันไดหนีไฟไม่มีของกีดขวาง",
      "ซ้อมแผนหนีไฟกับทุกคนในบ้าน และตรวจอุปกรณ์เตือนควันตามคำแนะนำของผู้ผลิต",
      "เก็บกุญแจ โทรศัพท์ แว่นตา และรองเท้าไว้ในจุดที่หยิบได้โดยไม่ขวางทางออก และบอกผู้ดูแลอาคารหากต้องการความช่วยเหลือในการอพยพ",
    ],
    during: [
      "ออกจากอาคารตามทางหนีไฟ ใช้บันได ไม่ใช้ลิฟต์",
      "ถ้ามีควันให้ก้มต่ำขณะออก และปิดประตูด้านหลังเมื่อทำได้อย่างปลอดภัย",
      "ไปยังจุดรวมพล ตรวจจำนวนคน และอยู่ห่างจากทางเข้าที่เจ้าหน้าที่ต้องใช้",
      "หากได้ยินสัญญาณเตือนในอาคารสาธารณะ ให้ทำตามเจ้าหน้าที่สถานที่และไม่รอให้เห็นเปลวไฟก่อนเริ่มออก",
    ],
    avoid: [
      "อย่ากลับไปเอาทรัพย์สิน และอย่าเปิดประตูที่มีความร้อนผิดปกติ",
      "ถ้ามีผ้าชุบน้ำอยู่ใกล้ตัว ใช้ปิดจมูกขณะหนีไฟได้ แต่ไม่ป้องกันก๊าซพิษและอย่าชะลอการหนี",
      "อย่าซ่อนตัวในห้องน้ำหรือพื้นที่ที่ไม่มีทางออก และอย่าพยายามดับไฟหากทางหนีไม่ชัดเจน",
      "อย่าเปิดหน้าต่างหรือประตูเพื่อระบายควันหากไม่รู้ว่าอยู่ฝั่งใดของไฟ เพราะอาจเพิ่มอากาศให้ไฟหรือเปิดทางให้ควัน",
    ],
    help: [
      "เมื่อออกมาแล้วให้แจ้งเหตุจากจุดปลอดภัยและบอกเจ้าหน้าที่หากยังมีคนอยู่ข้างใน",
      "การใช้ถังดับเพลิงหรือดับไฟชนิดต่าง ๆ ต้องรอคำแนะนำที่ผ่านผู้เชี่ยวชาญ",
      "หากออกไม่ได้ ให้ปิดประตู กั้นช่องควันเท่าที่ทำได้ ไปที่หน้าต่างหรือระเบียงที่ปลอดภัย และส่งสัญญาณขอความช่วยเหลือ",
      "เมื่อถึงจุดรวมพลแล้ว หากมีคนหาย ให้บอกชื่อ ตำแหน่งที่เห็นล่าสุด และความต้องการช่วยเหลือแก่เจ้าหน้าที่ แทนการย้อนกลับเข้าไปค้นหา",
    ],
    example:
      "ได้กลิ่นควันในอาคารและเห็นควันตามทางเดิน: ใช้ทางหนีไฟที่ปลอดภัย ก้มต่ำเมื่อมีควัน ใช้บันไดและไปจุดรวมพล ไม่ย้อนกลับเข้าไปเอาของ",
    situations: [
      {
        title: "ห้องพัก",
        text: "เมื่อได้ยินสัญญาณเตือน ให้ออกตามทางที่ปลอดภัยพร้อมกุญแจและโทรศัพท์ที่หยิบได้ทันที ไม่ใช้เวลารวบรวมของหรือแต่งตัว",
      },
      {
        title: "อาคารสำนักงาน",
        text: "ใช้บันไดและไปจุดรวมพลของอาคาร จากนั้นแจ้งเจ้าหน้าที่หากทราบว่ามีคนต้องการความช่วยเหลือหรือยังอยู่ในพื้นที่",
      },
      {
        title: "โรงแรม",
        text: "อ่านแผนหนีไฟหลังประตูห้องและหาทางออกสองทางเมื่อเข้าพัก ไม่รอเจ้าหน้าที่มาถึงหน้าห้องหากมีควันหรือสัญญาณเตือน",
      },
    ],
    checklist: [
      "รู้ทางออกสองทาง",
      "มีจุดรวมพล",
      "บันไดหนีไฟไม่มีของกีดขวาง",
      "ใช้บันได ไม่ใช้ลิฟต์",
      "ออกแล้วไม่กลับเข้าอาคาร",
      "รู้จุดรวมพลของสถานที่ที่ไปบ่อย",
      "เก็บของจำเป็นโดยไม่กีดขวางทางออก",
    ],
  },
  en: {
    notice: [
      "Smoke and fire gases can become dangerous before flames reach you.",
      "Escape routes and fire stairs differ between buildings.",
      "An alarm, burning smell, smoke, or an unusually hot door is a reason to leave without collecting belongings.",
      "Apartments, offices, hotels, and public venues may use different meeting points and evacuation instructions; read the local signs when you arrive.",
    ],
    prepare: [
      "Know at least two ways out and the building meeting point.",
      "Keep corridors, exits, and fire stairs clear.",
      "Practise the escape plan with everyone at home and test smoke alarms as their manufacturer directs.",
      "Keep keys, phone, glasses, and shoes accessible without blocking an exit, and tell building management if you need evacuation assistance.",
    ],
    during: [
      "Leave by the escape route; use stairs, not lifts.",
      "Stay low below smoke while leaving and close doors behind you when safe.",
      "Go to the meeting point, account for people, and keep entrances clear for responders.",
      "When an alarm sounds in a public building, follow venue staff and begin leaving; do not wait to see flames.",
    ],
    avoid: [
      "Do not return for belongings or open a door that feels unusually hot.",
      "If a damp cloth is at hand, cover your nose while escaping; it cannot protect against toxic gases, so do not delay leaving.",
      "Do not hide in a bathroom or place without an exit, and do not fight a fire when your escape route is unclear.",
      "Do not open a window or door to clear smoke unless you know where the fire is; it can feed the fire or draw smoke toward you.",
    ],
    help: [
      "Once outside, report the fire from a safe place and tell responders if anyone may remain inside.",
      "Extinguisher use and fire-type suppression remain pending specialist-reviewed guidance.",
      "If you cannot leave, close the door, limit smoke entry where possible, move to a safe window or balcony, and signal for help.",
      "At the meeting point, report a missing person's name, last known location, and assistance needs to responders instead of going back to search.",
    ],
    example:
      "You smell smoke in a building and see it in a corridor: use a safe escape route, stay low under smoke, take stairs to the meeting point, and do not return for belongings.",
    situations: [
      {
        title: "Room",
        text: "When an alarm sounds, leave by a safe route with only keys and a phone that are immediately available. Do not spend time collecting belongings or getting dressed.",
      },
      {
        title: "Office building",
        text: "Use stairs to the building meeting point, then tell staff if you know someone needs assistance or may still be inside.",
      },
      {
        title: "Hotel",
        text: "Read the escape plan behind the room door and locate two exits on arrival. Do not wait for staff at the door when there is smoke or an alarm.",
      },
    ],
    checklist: [
      "Know two exits",
      "Choose a meeting point",
      "Keep fire stairs clear",
      "Use stairs, not lifts",
      "Stay out once outside",
      "Know meeting points at frequent venues",
      "Keep essentials accessible without blocking exits",
    ],
  },
};
